define('taoQtiItem/qtiXmlRenderer/renderers/interactions/GraphicAssociateInteraction',['tpl!taoQtiItem/qtiXmlRenderer/tpl/interactions/blockInteraction'], function(tpl){
    return {
        qtiClass : 'graphicAssociateInteraction',
        template : tpl
    };
});
